import axios from 'axios'

const state = {
  lista: [],
  textoPesquisa: '',
  situacao: '1',
  tipo: '',
  registroSelecionadoId: null,
  recarregarLista: false
}

const mutations = {
  SET_LISTA (state, payload) {
    state.lista = payload
  },
  SET_TEXTO_PESQUISA (state, payload) {
    state.textoPesquisa = payload
  },
  SET_SITUACAO (state, payload) {
    state.situacao = payload
  },
  SET_TIPO (state, payload) {
    state.tipo = payload
  },
  SET_REGISTRO_SELECIONADO_ID (state, payload) {
    state.registroSelecionadoId = payload
  },
  SET_RECARREGAR_LISTA (state, payload) {
    state.recarregarLista = payload
  },
  SET_LIMPAR (state) {
    state.textoPesquisa = ''
    state.situacao = '1'
    state.tipo = ''
  }
}

const actions = {
  GET_LISTA: async ({ commit, state }) => {
    try {
      const filtros = {
        textoPesquisa: state.textoPesquisa,
        situacao: state.situacao,
        tipo: state.tipo
      }

      const { data } = await axios.post('/api/protected/centroEstoque/pesquisar', filtros)
      commit('SET_LISTA', data)
      commit('SET_RECARREGAR_LISTA', false)
      return data
    } catch (error) {
      console.error('Erro ao buscar lista de centros de estoque:', error)
      throw error
    }
  }
}

const getters = {
  lista: state => state.lista,
  textoPesquisa: state => state.textoPesquisa,
  situacao: state => state.situacao,
  tipo: state => state.tipo,
  registroSelecionadoId: state => state.registroSelecionadoId,
  recarregarLista: state => state.recarregarLista
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/centro-estoque-store.js